import { MutationTree } from 'vuex';
import { Role } from 'ctp-user-auth-service';

import { FETCH_CURRENT_USER_ROLE_PERMISSIONS,
  PermissionsState,
  SET_CURRENT_USER_ROLE_PERMISSIONS } from './types';

const mutations: MutationTree<PermissionsState> = {
  [FETCH_CURRENT_USER_ROLE_PERMISSIONS](state: PermissionsState, payload: Role) {
    state.currentUserRole = payload;
  },
  [SET_CURRENT_USER_ROLE_PERMISSIONS](state: PermissionsState, payload) {
    if (state.currentUserRole) {
      state.currentUserRole.permissions = payload;
    }
  }
};

export default mutations;
